module.exports = require("./logEntryFlex.vue");